<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getPlatformInfo } from '@/request/app'
export default {
  name: 'App',
  created () {
    this.getPlatformInfo()
  },
  methods: {
    getPlatformInfo () {
      let url = '/account-merchant-web/getSysInfo'
      getPlatformInfo(url, {}).then(res => {
        if (res.code === 0) {
          let logoArr = [{ name: '薪元', imageName: 'login_04' }, { name: '聚薪舍', imageName: 'nlogo_05' }, { name: '亮辅', imageName: 'login_01' }]
          let imageName = 'login_04'
          logoArr.forEach(e => {
            if (res.data.platform.indexOf(e.name) !== -1) imageName = e.imageName
          })
          res.data.imageName = imageName
          this.$store.dispatch('set_platformInfo', res.data)
          // console.log(document)
          document.title = res.data.platform + '共享经济综合服务平台'
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-input__inner,
/deep/.el-button,
/deep/.el-checkbox__inner,
/deep/.el-upload-dragger,
/deep/.el-textarea__inner {
  border-width: 1px !important; /*no*/
}
/deep/.el-checkbox__inner {
  &:after {
    border-width: 1px !important; /*no*/
  }
}
</style>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
  background: #f2f2f2;
  font-size: 14px;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
img {
  vertical-align: top;
  border: none;
}
.clearf:after,
.clearf:before {
  content: "";
  display: block;
  clear: both;
}
.el-input__inner {
  border-width: 1px; /*no*/
}
.el-button--default {
  border-width: 1px; /*no*/
}
.el-table__row td {
  border-width: 1px; /*no*/
}
.el-radio__inner {
  border-width: 1px; /*no*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue